export const RECEIVE_METER_LOCATIONS = 'RECEIVE_METER_LOCATIONS';
export const GET_METER_LOCATIONS = 'GET_METER_LOCATIONS';
export const SET_METER_LOCATION = 'SET_METER_LOCATION';
export const UPDATE_METER_LOCATION = 'UPDATE_METER_LOCATION';
export const DELETE_METER_LOCATION = 'DELETE_METER_LOCATION';
export const FETCH_METER_LOCATIONS = 'FETCH_METER_LOCATIONS';
